/** Works for Swedish personal number and coordination number */
export const formatIDNumberOnChange = (value: string) => {
  let newValue = value.replace(/[^0-9-]/g, '');
  const hasOneHyphen = newValue.split('-').length === 2;
  if (hasOneHyphen) {
    return newValue;
  }
  newValue = newValue.replace(/\D/g, '');
  if (newValue.length > 8) {
    newValue = `${newValue.slice(0, 8)}-${newValue.slice(8)}`;
  }
  return newValue;
};
